import { TParsers } from '@obvious.tech/constellation-swagger-parser-admin'
import { OpenAPIV2 } from 'openapi-types'

export type TDefinitionTypes = 'enums' | 'entities' | 'objects'

export type TDefinitionsByType = Record<
  TDefinitionTypes,
  Record<string, OpenAPIV2.SchemaObject>
>

export type TDefinitions = TDefinitionsByType & {
  swaggerDefinitions: {
    entities: Record<string, OpenAPIV2.SchemaObject>
    enums: TDefinitionsByType['enums']
  }
}

const getTypeKeyFromDefinition = (
  definition: OpenAPIV2.SchemaObject,
): TDefinitionTypes => {
  if (Array.isArray(definition.enum)) return 'enums'

  if (
    typeof definition.properties === 'object' &&
    Object.keys(definition.properties).includes('id')
  )
    return 'entities'

  return 'objects'
}

const definitionsCustomizations = (({ definitions = {} }): TDefinitions => {
  const { entities, enums, objects } = Object.entries(
    definitions,
  ).reduce<TDefinitionsByType>(
    (acc, [key, value]) => {
      const type = getTypeKeyFromDefinition(definitions[key])
      acc[type][key] = value
      return acc
    },
    {
      enums: {},
      entities: {},
      objects: {},
    },
  )

  const swaggerDefinitions = {
    entities: definitions,
    enums,
  }
  return {
    entities,
    enums,
    objects,
    swaggerDefinitions,
  }
}) satisfies TParsers['definitions']

export default definitionsCustomizations
